import { Injectable } from '@angular/core';
import {AccountingBaseService} from './accounting-base.service';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ZohobooksService extends AccountingBaseService {

  constructor(
    http: HttpClient,
  ) {
    super('zohobooks', http);
  }
}
